import { FetchState, InvestmentProfile, SingleInvestmentProfile } from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import * as bankService from "@/shared/api/bankService";
import { defineStore } from "pinia";
import _ from "lodash";
import { templatedFetchKeyStore } from "@/shared/store/fetchKeyedPlugin";

const emptyResourceGenerator = (): SingleInvestmentProfile => ({
    acountNumber: null,
    dateAccountInactivated: null
});

const valueSetter = (state: SingleInvestmentProfile, dto: InvestmentProfile) => {
    if (dto) {
        state.acountNumber = dto.accountNumber;
        state.dateAccountInactivated = dto.dateAccountInactivated;
    }
};


const useInvestmentProfileSubStore = defineStore("userInvestmentAccount_investmentProfile", () => {
    return templatedFetchKeyStore<SingleInvestmentProfile, InvestmentProfile>(
        emptyResourceGenerator,
        valueSetter,
        bankService.getInvestmentProfile
    );
});

export const useUserInvestmentAccountStore = defineStore("userInvestmentAccount", {
    getters: {
        investmentAccountNumber: () => useInvestmentProfileSubStore().acountNumber,
        investmentAccountActive: () => useInvestmentProfileSubStore().dateAccountInactivated === null,
        isLoading: () => useInvestmentProfileSubStore().fetchState === FetchState.Loading,
        isLoaded: () => useInvestmentProfileSubStore().fetchState === FetchState.Loaded,
    },
    actions: {
        async loadInvestmentAccount (
            args: {
                username?: string,
                partnerId?: number
            }): Promise<void> {

            return useInvestmentProfileSubStore().fetchKeyedApiCall(args)
                .catch(err => storeHelper.handleError({ error: err, rethrow: false }));
        },
    }
});
